var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteDestinationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7061 5.54961C20.4153 3.25882 17.3683 2 14.1301 2C10.8874 2 7.84484 3.25882 5.55406 5.54961C3.26327 7.8404 2 10.8874 2 14.1256C2 20.6777 8.19625 26.1311 11.5279 29.058C11.9905 29.4672 12.3864 29.8186 12.7067 30.1122C13.107 30.4858 13.6185 30.6727 14.1301 30.6727C14.6416 30.6727 15.1531 30.4858 15.549 30.1122C15.8693 29.8186 16.2696 29.4672 16.7322 29.058C20.0594 26.1311 26.2557 20.6777 26.2557 14.1256C26.2557 10.8874 24.9968 7.8404 22.7061 5.54961Z",
    fill: "#E05000",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteDestinationIcon);
export default __webpack_public_path__ + "static/media/routeDestinationIcon.83a322358c6696cde81bbce7a9760e32.svg";
export { ForwardRef as ReactComponent };